import {Injectable} from "@angular/core";
import {getRemoteConfig} from "@angular/fire/remote-config";
import {getApp} from "@angular/fire/app";


@Injectable({
  providedIn: 'root'
})
export class HubRemoteConfigService {
  initialiseRemoteConfig() {
    return getRemoteConfig(getApp("hub"));
  }
}
